import React from 'react'
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
// core components
import GridContainer from '../../../shared/components/Grid/GridContainer.jsx'
import GridItem from '../../../shared/components/Grid/GridItem.jsx'
import challengeStyle from '../../../shared/assets/jss/material-dashboard-pro-react/views/challengeStyle'
import MediaListForMarkdown from '../../../shared/components/Media/MediaListForMarkdown'
import MarkdownInput from '../../../components/MarkdownInput/MarkdownInput'

class ChallengeQuestionStop extends React.Component {
    constructor(props) {
        super(props)
	    const defaultQuestions = `Please provide and upload your responses in a short PDF document.

1. What did you learn from this challenge?
2. What suggestions do you have to improve this challenge?`

	    this.state = {
	          challengeQuestions: props.currentChallenge.challengeQuestions || defaultQuestions,
            questionsMediaFiles: [],
	          questionsMarkdownState: 'error'
        }
    }

    sendState() {
	    return { challengeQuestions: this.state.challengeQuestions }
    }

    handleChange = (event) => {
			this.setState({ challengeQuestions: event.target.value })
    }

    handleBlur = () => {
    }


    isValidated() {
        return this.state.challengeQuestions
               && this.state.challengeQuestions.length > 0
    }

    uploadMedia = (file, callback) => {
        this.props.uploadMedia(
            file.byteData,
            file.name,
            this.props.currentChallenge.uuid,
            mediaFile => callback(mediaFile),
            `${file.name} uploaded`
        )
    }

    render()
        {
            const {classes} = this.props
            return (
                <div>
                    <h4 className={classes.infoText}>Security Questions</h4>
                    <GridContainer justify="center">
                        <GridItem xs={12} sm={3}>
                            <MediaListForMarkdown
                                uploadedMediaFiles={this.state.questionsMediaFiles}
                                uploadMedia={this.uploadMedia}
                            />
                        </GridItem>
                        <GridItem xs={12} sm={9}>
	                        <div style={{width: '100%', overflow: 'hidden'}}>
		                        <MarkdownInput
			                        placeholder={`Add the questions for the students`}
			                        content={this.state.challengeQuestions}
			                        onChange={event => this.handleChange(event)}
			                        headingOffset={3}
			                        plainTabs={true}
			                        success={this.isValidated()}
			                        error={!this.isValidated()}
		                        />
	                        </div>
                        </GridItem>
                    </GridContainer>
                </div>
            )
        }
    }

    export default withStyles(challengeStyle)(ChallengeQuestionStop)
